import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';

import { isRtl } from 'modules/language/selectors/language';
import { Icon, Button, MaterialHint } from 'shared/components';
import { getName } from 'modules/appointmentInfo/utils/participantInfo';

import theme from './GroupNavigation.scss';

const GroupNavigation = ({
  appointmentGroup,
  setSelectedAppointmentId,
  changePatientInfoTab,
  currIndex,
  currSubjectName,
  intl,
  anchorEl,
  openPopover,
  closePopover,
  classes,
}) => (
  <div className={ theme.root }>
    <MaterialHint
      title={ intl.formatMessage({
        id: 'Appointment.GroupNavigationBar.PreviousBtn.Tooltip',
        defaultMessage: '** Previous appointment in group',
      }) }
      tooltipPlacement="bottom"
    >
      <span className={ currIndex === 0 ? theme.buttonDisabled : '' }>
        <button
          data-testid="previous-appt-in-group"
          className={ theme.navButton }
          onClick={ () => {
            const prevApptId = appointmentGroup[currIndex - 1].appointmentId;
            setSelectedAppointmentId(prevApptId);
          } }
          disabled={ currIndex === 0 }
        >
          <Icon name={ isRtl() ? 'chevron-right' : 'chevron-left' } />
        </button>
      </span>
    </MaterialHint>

    <Button buttonType="naked" size="small" className={ theme.subjectPickerButton } onClick={ openPopover }>
      <span>
        { intl.formatMessage({
            id: 'Appointment.GroupNavigationBar.Header',
            defaultMessage: '** {currentPos} out of {totalAppts} ({Patient_name})',
          },
          {
            currentPos: currIndex + 1,
            totalAppts: appointmentGroup.length,
            Patient_name: currSubjectName,
          }) }
      </span>
      <span className={ !!anchorEl ? theme.triangleTop : theme.triangleBottom } />
    </Button>

    <Menu
      anchorEl={ anchorEl }
      open={ !!anchorEl }
      onClose={ closePopover }
      getContentAnchorEl={ null }
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PopoverClasses={{
        paper: classes.topArrow,
      }}
    >
      { appointmentGroup.map(({ appointmentId, subject }, index) => (
        <MenuItem
          onClick={ () => {
            changePatientInfoTab('1');

            if (index !== currIndex) {
              setSelectedAppointmentId(appointmentId);
            }

            closePopover();
          } }
        >
          { intl.formatMessage({
              id: 'Appointment.GroupNavigationBar.Header',
              defaultMessage: '** {currentPos} out of {totalAppts} ({Patient_name})',
            },
            {
              currentPos: index + 1,
              totalAppts: appointmentGroup.length,
              Patient_name: getName(subject.user.profile, { withMiddleName: true }),
            },
          ) }
        </MenuItem>
      )) }
    </Menu>

    <MaterialHint
      title={ intl.formatMessage({
        id: 'Appointment.GroupNavigationBar.NextBtn.Tooltip',
        defaultMessage: '** Next appointment in group',
      }) }
      tooltipPlacement="bottom"
    >
      <span className={ currIndex + 1 === appointmentGroup.length ? theme.buttonDisabled : '' }>
        <button
          data-testid="next-appt-in-group"
          className={ theme.navButton }
          disabled={ currIndex + 1 === appointmentGroup.length }
          onClick={ () => {
            const nextApptId = appointmentGroup[currIndex + 1].appointmentId;
            setSelectedAppointmentId(nextApptId);
          } }
        >
          <Icon name={ isRtl() ? 'chevron-left' : 'chevron-right' } />
        </button>
      </span>
    </MaterialHint>
  </div>
);


export default GroupNavigation;
